import { toBoolOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultHistoryProgress } from '@/types/history/history-progress';
import type { IHistoryMiscFormValues, IHistoryMiscModel, IHistoryMiscSubmitResult } from '@/types/history/history-misc';

const HISTORY_MISC_ENDPOINT = '/api/register/history-misc';

const defaultHistoryMiscModel: IHistoryMiscModel = {
    ...defaultHistoryProgress,
    currentRegistrationStep: DashRegistrationStep.HistoryMisc,

    hasAllergies: null,
    allergies: [],
    hasHadSurgeries: null,
    surgeries: [],
    takesMedication: null,
    medicines: [],
};

export const useHistoryMisc = (registrationId: number, editKey: string) => {
    const url = `${HISTORY_MISC_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultHistoryMiscModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<IHistoryMiscFormValues, DashRegistrationStep, IHistoryMiscSubmitResult>(
        url,
        (values) => ({
            hasAllergies: toBoolOrNull(values.hasAllergies),
            allergies: values.allergies.map((x) => x.name),
            hasHadSurgeries: toBoolOrNull(values.hasHadSurgeries),
            surgeries: values.surgeries,
            takesMedication: toBoolOrNull(values.takesMedication),
            medicines: values.medicines,
        }),
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
